<template>
  <div>
    <router-view class="view-container" />
  </div>
</template>
<script>
export default {
  name: 'Points'
}
</script>
